const state = {
  token: localStorage.getItem('adminToken'),
}

const getters = {
  isLogin: state => !!state.token
}

const mutations = {
  login(state, token) {
    state.token = token
    localStorage.setItem('adminToken', token)
  },
  logout(state) {
    state.token = ''
    localStorage.setItem('adminToken', '')
  }
}

const actions = {
  login({ commit }, token) {
    commit('login', token)
  },
  logout({ commit }) {
    commit('logout')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}